import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './styles/reportPrint.css';
import logCaptureService from './services/logCaptureService';
import evidenceCollectorService from './services/evidenceCollectorService';

// Install frontend log capture (intercepts console.log/warn/error)
logCaptureService.install();

// Install evidence collector (console, network, Redux action interception)
evidenceCollectorService.install();

// Part 8: Capture unhandled promise rejections and errors
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  const message =
    reason instanceof Error ? reason.message :
    typeof reason === 'string' ? reason :
    JSON.stringify(reason);
  console.error('[UNHANDLED_REJECTION]', {
    message,
    stack: reason instanceof Error ? reason.stack : undefined,
    type: typeof reason,
  });
});

window.addEventListener('error', (event) => {
  console.error('[UNCAUGHT_ERROR]', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
  });
});

// Flush captured logs to the backend every 10 seconds
setInterval(() => {
  logCaptureService.flush().catch(() => { /* swallow flush errors silently */ });
}, 10_000);

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);